
export default {
  slug: "guerra-de-parrillas-16e",
  basepath: "content/gallery-16enero/",
  images: [
    { width: 534, height: 800, file: 'alfonso-franco.jpg', name: '' },
    { width: 1199, height: 800, file: '19.jpg', name: '' },
    { width: 1199, height: 800, file: '31.jpg', name: '' },
    { width: 534, height: 800, file: '25.jpg', name: '' },
    { width: 534, height: 800, file: '24.jpg', name: '' },
    { width: 1199, height: 800, file: '30.jpg', name: '' },
    { width: 1199, height: 800, file: 'christian-aguirre---francisca-escobar.jpg', name: 'Christian Aguirre' },
    { width: 534, height: 800, file: '37.jpg', name: '' },
    { width: 1199, height: 800, file: 'francisco-labra---michel-riff---alejandro-caro.jpg', name: 'Michel Riff y Alejandro Caro' },
    { width: 1197, height: 800, file: '21.jpg', name: '' },
    { width: 1199, height: 800, file: '35.jpg', name: '' },
    { width: 1199, height: 800, file: '2.jpg', name: '' },
    { width: 534, height: 800, file: 'alomso-quevedo.jpg', name: 'Alomso Quevedo' },
    { width: 534, height: 800, file: '1.jpg', name: '' },
    { width: 534, height: 800, file: 'samantha-cotton.jpg', name: 'Samantha Cotton' },
    { width: 1199, height: 800, file: '4.jpg', name: '' },
    { width: 1199, height: 800, file: 'angela-leschot---alvaro-nunez.jpg', name: 'Ángela Leschot y Álvaro Núñez' },
    { width: 1199, height: 800, file: '8.jpg', name: '' },
    { width: 1199, height: 800, file: '74.jpg', name: '' },
    { width: 1199, height: 800, file: 'ronald-medina---hector-mendez.jpg', name: 'Ronald Medina y Héctor Méndez' },
    { width: 534, height: 800, file: '77.jpg', name: '' },
    { width: 1199, height: 800, file: 'cristian-busta---cecilia-contreras-.jpg', name: 'Cristian Busta y Cecilia Contreras' },
    { width: 1199, height: 800, file: 'nicole-cardoen---paula-cardoen.jpg', name: 'Nicole Cardoen y Paula Cardoen' },
    { width: 534, height: 800, file: '29.jpg', name: '' },
    { width: 1199, height: 800, file: '14.jpg', name: '' },
  ]
}